module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 173.f33a3cce.png";